"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressItems = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("egov-ui-kit/redux/app/utils");

var _commons = require("egov-ui-kit/utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _PropertyInfoCard = require("../PropertyInfoCard");

var _PropertyInfoCard2 = _interopRequireDefault(_PropertyInfoCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = (0, _localStorageUtils.getLocale)() || "en_IN";
var localizationLabelsData = (0, _utils.initLocalizationLabels)(locale);

var getAddressItems = exports.getAddressItems = function getAddressItems(properties, OldProperty) {
  var oldTenantInfo = [],
      oldStateId = "",
      oldCityId = "",
      oldLocality = "";
  var _properties$address = properties.address,
      address = _properties$address === undefined ? {} : _properties$address,
      _properties$tenantId = properties.tenantId,
      tenantId = _properties$tenantId === undefined ? '' : _properties$tenantId;

  var tenantInfo = tenantId.split('.') || [];
  var stateId = tenantInfo && tenantInfo.length === 2 && tenantInfo[0] ? tenantInfo[0].toUpperCase() : 'NA';
  var cityId = tenantInfo && tenantInfo.length === 2 && tenantInfo[1] ? tenantInfo[1].toUpperCase() : 'NA';
  // const localityCode =address && address.locality && address.locality.code ? address.locality.code : 'NA';
  if (OldProperty) {
    oldTenantInfo = OldProperty.tenantId.split(".");
    oldStateId = oldTenantInfo[0] && oldTenantInfo[0].toUpperCase();
    oldCityId = oldTenantInfo[1] && oldTenantInfo[1].toUpperCase();
    oldLocality = OldProperty.address && OldProperty.address.locality && OldProperty.address.locality.code || 'NA';
  }

  return properties && [{
    key: "Ward",
    value: properties.ward || "NA",
    oldValue: OldProperty && OldProperty.properties && OldProperty.properties.ward
  }, {
    key: "Stree Code",
    value: properties.street || "NA",
    oldValue: OldProperty && OldProperty.properties && OldProperty.properties.street
  }, {
    key: "Premise Number",
    value: properties.premisesNo || "NA",
    oldValue: OldProperty && OldProperty.properties && OldProperty.properties.premisesNo
  }, {
    key: "Premise Type",
    value: properties.premisesType || "NA",
    oldValue: OldProperty && OldProperty.properties && OldProperty.properties.premisesType
  }];
};

var PropertyAddressInfo = function PropertyAddressInfo(_ref) {
  var properties = _ref.properties,
      editIcon = _ref.editIcon,
      OldProperty = _ref.OldProperty;


  var addressItems = [];
  var header = 'PT_PROPERTY_ADDRESS_SUB_HEADER';
  if (properties) {
    addressItems = getAddressItems(properties, OldProperty);
  }

  return _react2.default.createElement(_PropertyInfoCard2.default, { editIcon: editIcon, items: addressItems, header: header });
};

exports.default = PropertyAddressInfo;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/propertyTax/Property/components/PropertyAddressInfo/index.js
// module id = 1665
// module chunks = 1137